import { render, staticRenderFns } from "./NewsSearch.vue?vue&type=template&id=47dedcca&"
import script from "./NewsSearch.vue?vue&type=script&lang=js&"
export * from "./NewsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports